import { commonEnvShape, readCommonEnvVariables } from "@impero-com/common/env";
import { gitBranch, gitCommit } from "virtual:git-info";
import { z } from "zod";

const spaEnvVariables = z.object({
    ...commonEnvShape,
    PENDO_API_KEY: z.string(),
    GIT_COMMIT: z.string().optional(),
    GIT_BRANCH: z.string().optional(),
});

export const ENVIRONMENT = spaEnvVariables.parse({
    ...readCommonEnvVariables(),
    PENDO_API_KEY: import.meta.env.VITE_PENDO_API_KEY,
    GIT_COMMIT: gitCommit,
    GIT_BRANCH: gitBranch,
});
